
export const TITLE_MAKE_A_DONATION = 'Make a Donation'
export const TITLE_CHARITY_CONFIRMATION = "Giving"
export const NAME_CHARITY_SAVE_THE_CHILDREN = "Save The Children"

export const API_TIMEOUT = 2000